import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../models/auth.models';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class MenuService {
    constructor(private http: HttpClient) { }

    getAllListMenuByUser(): Observable<any> {
        return this.http.get(
            `${environment.API_BORYS_BACK}/gestionusuario/servicio/listamenuxrol`);
    }

    register(user: User): Observable<any> {
        return this.http.post(`/users/register`, user);
    }

    async getListMenuByUser(): Promise<any> {
        const result: Array<any> = await this.getAllListMenuByUser().toPromise()
        return result;
    }

    getListMenuPostman(): Observable<any>{
        return this.http.get(
          `${environment.API_BORYS_BACK}/gestionusuario/servicio/listamenu`);
    }

    listRolMenu(roleId : string):  Observable<any> {
        return this.http.post(
          `${environment.API_BORYS_BACK}/gestionusuario/servicio/listarolmenu`, {"roleId": roleId}, { observe: "response" }
        );
    }

    async getListRolMenu(params: any): Promise<any> {
        const result: any = await this.listRolMenu(params).toPromise()
        return result.body.roleList;
    }

    createRoleMenu(roleMenu: any): Observable<any> {
        return this.http.post(
          `${environment.API_BORYS_BACK}/gestionusuario/servicio/crearolmenu`, roleMenu);
    }

    updateRoleMenu(roleMenu: any): Observable<any> {
        return this.http.put(
          `${environment.API_BORYS_BACK}/gestionusuario/servicio/modificarolmenu`, roleMenu);
    }

    signout(): Observable<any> {
        return this.http.delete(
          `${environment.API_BORYS_BACK}/login/servicio/signout`);
    }

    
}
